import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ReactPlayer from "react-player";
import styles from "./index.module.css";
import {
  getCourseById,
  getPurchasedVideoById,
} from "../../../../../redux/features/course/courseService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";

const MyVideo = () => {
  const { slug, videoSlug } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isPurchasedVideoLoading, purchasedVideo } = useSelector(
    (state) => state.course.purchasedVideo
  );
  const { isCourseLoading, courseDetails, lessons } = useSelector(
    (state) => state.course.course
  );

  const [expandedLessons, setExpandedLessons] = useState({});

  useEffect(() => {
    dispatch(getPurchasedVideoById({ videoSlug }));
  }, [dispatch, videoSlug]);

  useEffect(() => {
    dispatch(getCourseById({ slug }));
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [slug]);

  const toggleDetails = (id) => {
    setExpandedLessons((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const openVideoPage = (videoSlug) => {
    // dispatch(getPurchasedVideoById({ videoSlug }));
    navigate(`/my-courses/${slug}/${videoSlug}`);
  };

  return (
    <>
      <div className={styles.bgSection}>
        {isPurchasedVideoLoading ? (
          <div className={`main-container`}>
            <div className={`container-content`}>
              <div className={styles.videoSecBody}>
                <div className={styles.videoSec}>
                  <Skeleton height={500} />
                  <p>
                    <Skeleton height={30} />
                  </p>
                  <div>
                    <Skeleton />
                    <Skeleton />
                  </div>
                </div>
                <div className={styles.videoListSec}>
                  <div className={styles.courseLessonsSec}>
                    <div className={styles.videoListHeader}>
                      <p className={styles.headerTitle}>
                        <Skeleton />
                      </p>
                    </div>
                    <div className={styles.videoListBody}>
                      {Array.from({ length: 5 }).map((_, index) => (
                        <div className={styles.titles} key={index}>
                          <div className={`primary-box  ${styles.showBox}`}>
                            <div className={styles.descRow}>
                              <Skeleton className={styles.thumbnailImg} />
                              <div className={styles.name}>
                                <p>
                                  <Skeleton width={200} />
                                </p>
                                <p className={styles.descText}>
                                  <Skeleton />
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          purchasedVideo?.length > 0 && (
            <div className={`main-container`}>
              <div className={`container-content`}>
                <div className={styles.videoSecBody}>
                  <div className={styles.videoSec}>
                    <div className={styles.videoWrapper}>
                      <ReactPlayer
                        url={purchasedVideo[0]?.course?.sub_titles[0]?.videos[0]?.video_url}
                        width="100%"
                        height="500px"
                        controls
                        playing={false}
                        playsinline
                        config={{
                          vimeo: {
                            playerOptions: {
                              autoplay: false,
                              muted: false,
                              loop: false,
                              title: false,
                              byline: false,
                              portrait: false,
                              speed: true,
                              transparent: false,
                            },
                          },
                        }}
                      />
                    </div>
                    <h1 className={styles.videoTitle}>
                      {purchasedVideo[0]?.course?.sub_titles[0]?.videos[0]?.title}
                    </h1>
                    <p>{purchasedVideo[0]?.course?.sub_titles[0]?.videos[0]?.description}</p>
                    {purchasedVideo[0]?.course?.sub_titles[0]?.videos[0]?.doc_url && (
                      <div
                        className={styles.docRow}
                        onClick={() =>
                          window.open(
                            purchasedVideo[0]?.course?.sub_titles[0]?.videos[0]?.doc_url,
                            "_blank"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        <FontAwesomeIcon icon={faFilePdf} />
                        <p className={styles.videoDocTitle}>
                          {purchasedVideo[0]?.course?.sub_titles[0]?.videos[0]?.doc_title}
                        </p>
                      </div>
                    )}
                  </div>
                  <div className={styles.videoListSec}>
                    <div className={styles.courseLessonsSec}>
                      <div className={styles.videoListHeader}>
                        <p className={styles.headerTitle}>
                          {purchasedVideo[0]?.course?.title}
                        </p>
                      </div>
                      <div className={styles.videoListBody}>
                        {[...lessons]
                          .sort((a, b) => a.index - b.index)
                          .map((lesson) => (
                            <div className={styles.titles} key={lesson.id}>
                              <div className={styles.lessonListHeader}>
                                <p className={styles.subTitle}>
                                  {lesson?.title}
                                </p>
                              </div>
                              {lesson.videos?.map((video) => (
                                <div
                                  className={`primary-box  ${styles.showBox} ${purchasedVideo[0]?.course?.sub_titles[0]?.videos[0]?.id ===
                                      video.id
                                      ? `${styles.activeBox}`
                                      : ""
                                    }`}
                                  key={video.id}
                                >
                                  <div className={styles.descRow}>
                                    <img
                                      src={video?.image_url}
                                      className={styles.thumbnailImg}
                                    />
                                    <div
                                      className={styles.name}
                                      onClick={() => openVideoPage(video.slug)}
                                    >
                                      <p className={styles.titleWidth}>
                                        {video.title}
                                      </p>
                                      <p className={styles.descText}>
                                      {video.description.length > 50
                                        ? video.description.substring(0, 60) +
                                          "..."
                                        : video.description}
                                    </p>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </>
  );
};

export default MyVideo;
